import { BLink } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

export const EgBLink = createEgBootstrapProxy("EgBLink", BLink);
